import type { AccessRolAction, AccessRolSection } from '@/shared/access';

export const COLLECT_ACCESS_SECTION = 'COLLECT' satisfies AccessRolSection;

export const COLLECT_ACCESS_ACTIONS = [
  'VIEW',
  'CREATE',
] as const satisfies readonly [AccessRolAction, ...AccessRolAction[]];
